import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Config from '../definitions/Config';
import messageToString from '../functions/messageToString';
import getBrandLogo from '../functions/getBrandLogo';
import MessagePropType from '../definitions/MessagePropType';


const VARIANTS = {
    DARK: 'dark',
    LIGHT: 'light',
};

function LogoFull({
    variant = VARIANTS.DARK,
    imageAlt,
    width,
    height,
    ...otherProps
}) {
    const intl = useIntl();

    // Currently based on Config.SITE_BRANDING, which limits us to only
    // showing ratehub.ca || rhinsurance.ca brands. Could expand this to
    // allow showing any brand logo, but would require API changes on this
    // component.
    const options = {
        theme: variant,
    };
    const logo = getBrandLogo(Config.SITE_BRANDING, options);

    if (!logo) {
        // eslint-disable-next-line no-console
        console.warn(`LogoFull: could not get brand logo for brand '${Config.SITE_BRANDING}' with options: ${options}`);
        return null;
    }

    return (
        <img
            src={logo?.filePath}
            width={width ?? logo?.intrinsicWidth}
            height={height ?? logo?.intrinsicHeight}
            alt={messageToString(imageAlt ?? logo?.altText, intl)}
            {...otherProps}
        />
    );
}

LogoFull.propTypes = {
    variant: PropTypes.oneOf(Object.values(VARIANTS)),
    imageAlt: MessagePropType,
    width: PropTypes.number, // unitless, but interpreted as pixels
    height: PropTypes.number, // unitless, but interpreted as pixels
};

export default LogoFull;
